import "../assets/css/spinner.css";
import { Oval } from "react-loader-spinner";

export default function LoadingSpinner({
  spinnerText = "",
  description = "",
  titleStyle = {},
  descriptionStyle = {},
  isHomeLoader = false,
}) {
  return (
    <div className="spinner-container">
      <div className="loading-spinner">
        <div className={isHomeLoader ? "spinnerHome" : "spinner"}>
          <Oval
            height={52}
            width={52}
            color="#F9DA87"
            wrapperStyle={{}}
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#8588bba1"
            strokeWidth={4.5}
            strokeWidthSecondary={4.5}
          />
          <div className="spinnerText" style={titleStyle}>
            {spinnerText}
          </div>
          <div className="description" style={descriptionStyle}>
            {description}
          </div>
        </div>
      </div>
    </div>
  );
}
